<div class="modal-wrapper">
  <div class="modal-header">
    <i
      class="fas fa-times clickable"
      (click)="activeModal.dismiss('Cross click')"
    ></i>
  </div>
  <div class="modal-body">
    <div class="building-group-nav-wrapper">
      <div class="building-group-nav-item">
        <div class="building-group-nav-icon-wrapper">
          <div
            class="building-group-nav-icon"
            (click)="openAddToExistingGroupModal()"
          >
            <img
              src="assets/Keen&Wise_add to existing BG_small_blue_transparant.png"
              alt="Add building to group"
            />
          </div>
        </div>
        <p i18n="@@buildinggroup.addbuildingstoexistinggroup">
          Add selected buildings to <b>existing building group</b>
        </p>
      </div>
      <div class="building-group-nav-item">
        <div class="building-group-nav-icon-wrapper">
          <div
            class="building-group-nav-icon"
            (click)="openAddToNewGroupModal()"
          >
            <img
              src="assets/Keen&Wise_add to new BG_small_blue_transparant.png"
              alt="Add building group"
            />
          </div>
        </div>
        <p i18n="@@buildinggroup.newgroupwithbuildings">
          Create <b>new building group</b> with selected buildings
        </p>
      </div>
    </div>
  </div>
</div>
